


















import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import {
  IHospitalizedHisInformationItemSelectBehavior,
  IObjectReferableFeature,
  ILinkedPageObjectSpecifiable,
  ILinkedObjectSpecifiable,
} from "../../../../domain/format/objects";
import { CommonComponentsContainer } from "../../../../../formatEditor/components/format/editors/contents";
import { FormatObjectSelectorColumnTypes } from "../../../../../formatEditor/components/format/editors/contents/commonComponents/selectors";
import { IFormatObjectEditable } from "../../../../../formatEditor/domain/editableFormat";
import { DateObjectEditor } from "../../../../../formatEditor/domain/editableFormat/objectEditors";

@Component
export default class HospitalizedHisInformationItemDefaultSelectBehaviorEditor extends Mixins(ModelEditableMixin) {
  @Prop()
  isEditable: boolean;

  @Prop()
  commonComponents: CommonComponentsContainer;

  writePropertyWhenValid: (writer: (source: IHospitalizedHisInformationItemSelectBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IHospitalizedHisInformationItemSelectBehavior) => T, defaultValue: T) => T;

  get shouldSelectHospitalizedOnly(): boolean {
    return this.readPropertyOrDefault(s => s.shouldSelectHospitalizedOnly, false);
  }

  set shouldSelectHospitalizedOnly(value: boolean) {
    this.writePropertyWhenValid(s => s.shouldSelectHospitalizedOnly = value);
  }

  get baseDateReferBehavior(): IObjectReferableFeature<ILinkedPageObjectSpecifiable> {
    return this.readPropertyOrDefault(s => s.baseDateReferBehavior, null);
  }

  set baseDateReferBehavior(value: IObjectReferableFeature<ILinkedPageObjectSpecifiable>) {
    this.writePropertyWhenValid(s => s.baseDateReferBehavior = value);
  }

  get dateObjects(): ILinkedPageObjectSpecifiable[] {
    return Enumerable.from(this.commonComponents.allPagesFormatObjectsForEachPage)
      .selectMany(p => Enumerable.from(p.objects)
        .where(o => this.conditionsOfEachElementType(o))
        .select(o => this.toLinkedPageObjectSpecifiable(o, p.pageKey))
        .toArray())
      .toArray();
  }

  private conditionsOfEachElementType(object: IFormatObjectEditable): boolean {
    const linkedObject = object.toLinkedObjectIdentifier();
    return !object.isSelected() && this.isSelectableObject(object) && !!linkedObject.id && !!linkedObject.key && linkedObject.key !== "";
  }

  private isSelectableObject(object: IFormatObjectEditable) {
    return (object instanceof DateObjectEditor) && object.objectTypeName().getValue() === "date" && object.isDate().getValue();
  }

  private toLinkedPageObjectSpecifiable(object: IFormatObjectEditable, pageKey: number): ILinkedPageObjectSpecifiable {
    const linkedObject = object.toLinkedObjectIdentifier();
    return {
      pageKey: pageKey,
      type: linkedObject.type,
      id: linkedObject.id,
      key: linkedObject.key,
      subKey: linkedObject.subKey,
      tableIndex: linkedObject.tableIndex,
      isDate: linkedObject.isDate,
    };
  }

  @Watch("isEditable")
  onIsHospitalizationItemUpdated(newValue: boolean, oldValue: boolean) {
    if (!newValue && this.editingSource.shouldSelectHospitalizedOnly) {
      this.editingSource.shouldSelectHospitalizedOnly = false;
    }
  }

  async showBaseDateEditDialog() {
    const dialog = this.commonComponents.getDialogs().getFormatObjectSingleSelectDialog();
    const reference = await dialog.show(
      this.baseDateReferBehavior.reference,
      this.dateObjects,
      ["key", "id", "pageNumber"],
      [],
      this.toCellString);
    if (reference === undefined) { return; }
    this.baseDateReferBehavior = { reference, isEnable: !!reference };
  }

  private toCellString(column: FormatObjectSelectorColumnTypes, row: ILinkedPageObjectSpecifiable): string {
    const formatObject = this.getFormatObjectEditable(row);
    switch (column) {
      case "id":
        return row.id ? row.id.toString() : "";
      case "key":
        return formatObject && formatObject.getIdentifiableName()
          ? formatObject.getIdentifiableName()
          : row.key;
      case "pageNumber":
        const pageNumber = this.commonComponents.getPageNumber(row.pageKey);
        return pageNumber === 0 ? "削除済" : pageNumber.toString();
      default:
        return "";
    }
  }

  private getFormatObjectEditable(row: ILinkedObjectSpecifiable): IFormatObjectEditable {
    return Enumerable.from(this.commonComponents.allPagesFormatObjects)
      .firstOrDefault(o => {
        const linkedObject = o.toLinkedObjectIdentifier();
        return linkedObject.type === row.type &&
          linkedObject.id === row.id &&
          linkedObject.key === row.key &&
          linkedObject.isDate === row.isDate;
      });
  }
}
